package com.wintermar.inspection.feature.presentation.inspection.complete

actual suspend fun processAfterApprove(
    inspectionId: String,
    onNavigateToLanding: suspend () -> Unit,
    onDeleteInspection: suspend (String) -> Unit
) {
    onNavigateToLanding()
}
